export default "__VITE_ASSET__Cc581Xcb__"